export const languages = [
  {
    label: "English",
    code: "en",
    flag: "gb.svg",
  },
  {
    label: "French",
    code: "fr",
    flag: "fr.svg",
  },
  {
    label: "Kirundi",
    code: "rw",
    flag: "rw.png",
  },
];
